export class ExportFile {
  fileId: string;
  fileName: string;
  filePath: string;
  programName: string;
  programCode: string;
  dateCreated: number;
  dateDownloaded: number;
  downloadedBy: string;
  userId: string;
  checked: boolean;
}
